import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function CommunityCTA() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const targetPos = target.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top: targetPos, behavior: 'smooth' });
    }
  };

  return (
    <section className="community-cta" id="community" aria-labelledby="community-heading">
      <div className="community-cta-inner">
        <span className="eyebrow reveal">Stay connected</span>
        <h2 id="community-heading" className="reveal">
          Partner with us to shape Berthoud&rsquo;s future.
        </h2>
        <p className="reveal">
          When development is guided by the community it serves, Berthoud becomes an even richer, more cohesive
          version of itself. Whether you&rsquo;re a neighbor, a town leader, or someone considering Berthoud as home,
          we&rsquo;d like to hear from you.
        </p>
        <div className="cta-buttons reveal">
          <a href="#contact" className="btn btn-primary" onClick={(e) => handleClick(e, '#contact')}>
            Start a conversation
            <ArrowRight className="btn-icon" strokeWidth={1.5} aria-hidden="true" />
          </a>
          <a href="#projects" className="btn btn-secondary" onClick={(e) => handleClick(e, '#projects')}>
            See what we&rsquo;re building
          </a>
        </div>
      </div>
    </section>
  );
}
